export default __webpack_public_path__ + "static/media/cursor-pencil.9808a54f.svg";